import React, { forwardRef } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  size?: 'lg' | 'md';
  className?: string;
};
export const CtaButton = forwardRef<HTMLAnchorElement, CtaButtonProps>(function CtaButton({
  label,
  size = 'lg',
  className = ''
}, ref) {
  const sizing = size === 'lg' ? 'min-h-[64px] px-5 py-4 text-[17px] md:text-xl' : 'min-h-[56px] px-5 py-3 text-base';
  return <a ref={ref} href={CHECKOUT_URL} className={`group inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-cta-400 text-center font-extrabold uppercase leading-tight tracking-tight text-ink-950 shadow-[0_6px_0_0_#A16207] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-300 active:translate-y-[4px] active:shadow-[0_2px_0_0_#A16207] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-300 ${sizing} ${className}`} data-id="element-27" data-mp="llh4fgrubivb">
      <span className="text-balance" data-id="element-28" data-mp="35xfo76wcd5aa">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-29" data-mp="35yqrl5lvkb0v" />
    </a>;
});